// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
// import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: 'AIzaSyCo3PV3iB7LmrmgAJ8NQbpvpFxifmXhd8k',
  authDomain: 'el-haram-el-rabe.firebaseapp.com',
  projectId: 'el-haram-el-rabe',
  storageBucket: 'el-haram-el-rabe.appspot.com',
  messagingSenderId: '1048762893498',
  appId: '1:1048762893498:web:cd01f969b5dea381966e83',
  measurementId: 'G-FMRVWBP35R',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

const db = getFirestore();

export { db, app };
